import * as React from 'react';
import { Button } from '@cian/ui-kit';

export interface IShowPhoneButtonProps {
  onClick?(): void;
}

export const ShowPhoneButton: React.VFC<IShowPhoneButtonProps> = ({ onClick }) => {
  return (
    <Button onClick={onClick} size="M" type="button" data-testid="ShowPhoneButton" fullWidth>
      Показать телефон
    </Button>
  );
};
